export default () => ({
  root: {
    flexGrow: 1
  },
  uploadInput: {
    display: 'none'
  }
})
